import React from 'react';
import { getKompisIconData, IconProps } from './utils/kompis/getKompisIconData';
import { KompisIconPill } from '@inter-ikea-kompis/react-components';
import IconPillSizeOptionsEnum from '@inter-ikea-kompis/component-icon-pill/lib/enums/IconPillSizeOptionsEnum';

interface IconPillProps extends IconProps {
  iconPillSize: IconPillSizeOptionsEnum;
  onSelect: () => any;
  selected: boolean;
  disabled: boolean;
}

export const IconPill: React.FunctionComponent<IconPillProps> = ({
  iconName,
  ...props
}) => <KompisIconPill {...props} {...getKompisIconData(iconName)} />;
